import * as React from 'react';
import styled from 'styled-components';
import { connectSsr } from '@bart.sk-eshop/ssr-service';
import { connect } from 'react-redux';
import MetaTags from '../../components/MetaTags/MetaTags';
import { CatalogRow, MainCol, CategoriesCol } from '../../theme/libraries/grid';
import {
  capitalizeFirstLetter,
  categoryMetaHandler,
  prop,
  removePTag,
} from '../../utilities';
import SideMenu from '../../components/_layout/SideMenu/SideMenu';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import {
  ContainerIndent,
  Title,
} from '../../components/_layout/Page/ContentContainer';
import { MediaContextProvider } from '../../theme/media';
import API from '../../services/API';
import { useState } from 'react';
import { __ } from '@bart.sk-eshop/react-i18n/lib';
import CategoriesFurniture from '../../components/_helpers/Categories/CategoriesFurniture';
import { rem } from 'polished';
import { setCurrentCategoryGroupId } from '../App/actions';
import {
  CategoryDescriptionWrapper,
  DescriptinoText,
  InfoIcon,
  ShowMoreButton,
  mergeCategoriesWithSubgroups,
} from './Category';

const TitleStyled = styled(Title)`
  margin-bottom: ${rem(32)};
`;

const FlushSideMenu = styled(SideMenu)`
  ${({ theme }) => theme.media('md')} {
    margin-top: -${rem(20)};
  }
`;

export interface CategoryProps {
  category?: any;
  dispatch: any;
  categoriesGroup?: any[];
  currentPath?: string;
}

const FurnitureCategoryGroup = (props: CategoryProps) => {
  const { category, dispatch, categoriesGroup, currentPath } = props;

  const [categoryGroup, setCategoryGroup] = useState([] as any);
  const [categoryGroupContent, setCategoryGroupContent] = useState<any>(null);
  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);

  React.useEffect(() => {
    const groupSearchParams: any = {
      active: '1',
      withCategories: 1,
      categoryTree: true,
      limit: 1,
      filterEmpty: true,
      filterDisabled: true,
      mergeSubgroupCategories: true,
    };
    if (props.category.type === 'subgroup') {
      groupSearchParams.hasSubgroupId = props.category.id;
    } else {
      groupSearchParams.id = props.category.id;
    }
    API.loadCategoriesGroups(groupSearchParams).then((categoriesGroup) => {
      if (categoriesGroup.total) {
        setCategoryGroup(
          mergeCategoriesWithSubgroups(
            categoriesGroup.catalog_category_groups[0],
          ),
        );
        setCategoryGroupContent(
          categoriesGroup.catalog_category_groups[0].content,
        );
        setCurrentCategoryGroupId(props.category.id);
      }
    });
  }, [props.category.id]);

  const items: any = [
    {
      name: __('Internetový obchod'),
      url: '/',
    },
    {
      name: capitalizeFirstLetter(category.name),
      url: category.url,
    },
  ];

  const body =
    categoryGroupContent &&
    categoryGroupContent.draft !== true &&
    typeof categoryGroupContent.json_content?.body === 'string'
      ? removePTag(categoryGroupContent.json_content?.body)
      : null;

  const onDescriptionButtonClick = async () => {
    setIsDescriptionOpen(!isDescriptionOpen);
  };

  const renderCategoryDesctiption = (body, shortBody) => {
    if (shortBody && body) {
      return (
        <CategoryDescriptionWrapper isEnd={isDescriptionOpen ? true : false}>
          <DescriptinoText
            dangerouslySetInnerHTML={{
              __html: shortBody,
            }}
          />

          {isDescriptionOpen ? (
            <ShowMoreButton onClick={onDescriptionButtonClick}>
              {' '}
              <InfoIcon icon="info" />
              {__('Menej informácií')}
            </ShowMoreButton>
          ) : (
            <ShowMoreButton onClick={onDescriptionButtonClick}>
              {' '}
              <InfoIcon icon="info" />
              {__('Viac informácií')}
            </ShowMoreButton>
          )}

          {isDescriptionOpen ? (
            <DescriptinoText
              dangerouslySetInnerHTML={{
                __html: body,
              }}
            />
          ) : (
            <></>
          )}
        </CategoryDescriptionWrapper>
      );
    } else if (shortBody) {
      return (
        <CategoryDescriptionWrapper isEnd={true}>
          <DescriptinoText
            dangerouslySetInnerHTML={{
              __html: shortBody,
            }}
          />
        </CategoryDescriptionWrapper>
      );
    } else if (body) {
      return (
        <CategoryDescriptionWrapper isEnd={true}>
          <DescriptinoText
            dangerouslySetInnerHTML={{
              __html: body,
            }}
          />
        </CategoryDescriptionWrapper>
      );
    }

    return <></>;
  };

  return (
    <MediaContextProvider>
      <ContainerIndent className="base">
        <MetaTags tags={categoryMetaHandler(category, 'sk', 'Daffer.sk')} />
        <CatalogRow>
          <CategoriesCol>
            <FlushSideMenu
              categoriesGroup={categoriesGroup || []}
              dispatch={dispatch}
              currentPath={currentPath}
              furniture={true}
            />
          </CategoriesCol>
          <MainCol>
            <Breadcrumbs items={items} />
            <TitleStyled>{capitalizeFirstLetter(category.name)}</TitleStyled>
            {renderCategoryDesctiption(body, null)}
            <CategoriesFurniture categories={categoryGroup} />
          </MainCol>
        </CatalogRow>
      </ContainerIndent>
    </MediaContextProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    categoriesGroup: state.general.categoriesGroup,
    currentPath: prop(state.routing, 'locationBeforeTransitions.pathname', ''),
  };
};

export default connect(mapStateToProps)(
  connectSsr({ displayName: 'FurnitureCategoryGroup' })(FurnitureCategoryGroup),
);
